import React from "react";
import { motion } from "framer-motion";
import { TrendingUp } from "lucide-react";
import { Card, CardContent } from "../components/ui/Card.jsx";
import BloombergNews from "../components/ui/Headlines.jsx";
import ZeroHedgeNews from "../components/ui/ZeroHedgeNews";
import ClockCalendar from "../components/ui/ClockCalendar";
import LiveBadge from "../components/ui/LiveBadge.jsx";
import { useLoading } from "../context/LoadingContext";

const YouTubeLive = ({ className = "shrink-0" }) => {
  return (
    <Card
      className={`flex flex-col overflow-hidden border-0 bg-transparent p-0 shadow-none ${className}`}
    >
      <CardContent className="flex min-h-[300px] flex-1 flex-col p-0 lg:min-h-0">
        <div className="relative w-full flex-1 min-h-0 overflow-hidden bg-black">
          <iframe
            className="absolute inset-0 h-full w-full"
            src="https://www.youtube-nocookie.com/embed/QB5BNdBFujE?autoplay=1&mute=1"
            title="Bloomberg Business News Live"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          />

          <div className="absolute left-3 top-3 z-20">
            <LiveBadge />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

const Dashboard = () => {
  const { isLoading } = useLoading();

  return (
    <motion.div 
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: isLoading ? 0 : 1, y: isLoading ? 10 : 0 }}
      transition={{ duration: 0.5 }}
      className="w-full min-h-[calc(95vh-6rem)] lg:h-[calc(95vh-5rem)] p-1 flex flex-col gap-4 z-10"
    >

      {/* Grille principale */}
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-4 flex-1 min-h-0">

        {/* Colonne gauche */}
        <div className="flex flex-col gap-4 lg:col-span-2 h-full min-h-0">
          {/* Bloc 1: En-tête */}
          <div className="flex items-center gap-3 shrink-0">
            <TrendingUp className="w-8 h-8 text-secondary" />
            <h1 className="text-3xl font-bold text-primary tracking-tight">
              Tableau de Bord
            </h1>
          </div>

          {/* Bloc 2: Contenu principal gauche */}
          <div className="flex flex-col gap-4 flex-1 min-h-0">
            <Card className="workspace-card-elevated shadow-hp-md flex min-w-0 flex-col overflow-hidden shrink-0">
              <CardContent className="min-w-0 p-0">
                <ClockCalendar />
              </CardContent>
            </Card>

            <Card className="workspace-card-elevated shadow-hp-md flex flex-col flex-1 min-h-0">
              <CardContent className="p-4 flex-1 overflow-y-auto">
                <ZeroHedgeNews />
              </CardContent>
            </Card>
          </div>
        </div>

        {/* Colonne droite (Bloc 3) */}
        <div className="flex flex-col gap-4 lg:col-span-3 h-full min-h-0">
          <YouTubeLive className="flex-[1.6] lg:flex-[2.3] min-h-0" />

          <Card className="flex flex-1 min-h-0 min-w-0 flex-col overflow-hidden border-0 bg-transparent p-0 shadow-none">
            <CardContent className="flex flex-1 min-h-0 min-w-0 overflow-hidden p-0">
              <BloombergNews className="h-full w-full" />
            </CardContent>
          </Card>
        </div>

      </div>
    </motion.div>
  );
};

export default Dashboard;
